import React from "react";
const TaskManagement = React.lazy(() => import('./TaskManagement'));

export const taskManagementConfig = [
    {
        path: '/apps/taskmanagement',
        element: <TaskManagement />
    },
    {
        path: '/apps/taskmanagement/tambah-task/:project_id/:list_id',
        element: <TaskManagement />
    },
    {
        path: '/apps/taskmanagement/tambah-task/:project_id/:list_id/:status',
        element: <TaskManagement />
    },
    {
        path: '/apps/taskmanagement/tambah-project',
        element: <TaskManagement />
    },
    {
        path: '/apps/taskmanagement/edit-project/:project_id',
        element: <TaskManagement />
    },
    {
        path: '/apps/taskmanagement/edit-task/:id',
        element: <TaskManagement />
    },
    {
        path: '/apps/taskmanagement/detail/:id',
        element: <TaskManagement />
    },
    {
        path: '/apps/taskmanagement/detail-task-korespondensi/:id',
        element: <TaskManagement />
    }
];

